export default "__VITE_ASSET__d0e831d7__"